import { VOUCHERS_ENABLED } from './features.js';

// Both role editors use this catalog. Labels are resolved at render time via
// settings.roles.groups/perms; a contract test checks the backend catalog.
const ORG_GROUPS = [
  { key: 'project_reports', perms: ['project_notes:read_all', 'project_notes:manage', 'project_reports:read', 'project_reports:generate', 'project_reports:publish'] },
  { key: 'customers', perms: ['customers:read', 'customers:create', 'customers:delete', 'team:activity:read'] },
  { key: 'documents', perms: ['documents:read', 'documents:create', 'documents:send'] },
  { key: 'costs', perms: ['costs:read', 'costs:write', 'costs:approve', 'costs:routes_read'] },
  { key: 'evidence', perms: ['evidence:read', 'evidence:write'] },
  { key: 'extraction', perms: ['extraction:read', 'extraction:review'] },
  { key: 'finance', perms: ['finance:read', 'finance:manage'] },
  { key: 'project_finance', perms: ['project_finance:read', 'project_finance:manage'] },
  { key: 'purchasing', perms: ['purchasing:read', 'purchasing:write', 'purchasing:approve'] },
  { key: 'vouchers', perms: ['vouchers:read', 'vouchers:write'] },
  { key: 'time', perms: ['time:read', 'time:write', 'time:approve'] },
  { key: 'worktime', perms: ['worktime:read', 'worktime:write'] },
  { key: 'wages', perms: ['wages:read', 'wages:write'] },
  { key: 'calculation', perms: ['units:read', 'units:write', 'surcharges:read', 'surcharges:write', 'bausteine:read', 'bausteine:write'] },
  { key: 'accounting', perms: ['accounting:read', 'accounting:write'] },
  { key: 'layout', perms: ['layout:read', 'layout:write'] },
  { key: 'holidays', perms: ['holidays:read', 'holidays:write'] },
  { key: 'leads', perms: ['leads:read', 'leads:write'] },
  { key: 'appointments', perms: ['appointments:read', 'appointments:write'] },
  { key: 'members', perms: ['members:read', 'members:invite', 'members:write', 'members:remove'] },
  { key: 'roles', perms: ['roles:read', 'roles:write'] },
  { key: 'org', perms: ['org:settings'] },
  { key: 'communication', perms: ['email:read', 'whatsapp:send'] },
  { key: 'ai', perms: ['prompts:read', 'prompts:write', 'credentials:read', 'credentials:write'] },
  { key: 'automation', perms: ['scenarios:read', 'scenarios:write', 'scenarios:delete', 'scenarios:run', 'connections:read', 'connections:write', 'connections:delete', 'executions:read'] },
];
const PLATFORM_GROUP = {
  key: 'platform',
  perms: ['platform:orgs:read', 'platform:orgs:write', 'platform:audit:read', 'platform:assistant:read', 'platform:usage:read'],
};

export function rolePermissionGroups(isPlatform = false) {
  const visible = ORG_GROUPS.filter(group => group.key !== 'vouchers' || VOUCHERS_ENABLED);
  return isPlatform ? [...visible, PLATFORM_GROUP] : visible;
}

/** Preserve unrendered grants during client/server version overlap; allow explicit revocation. */
export function mergeRolePermissions(existing, checkboxControls) {
  const controls = Array.from(checkboxControls);
  const rendered = new Set(controls.map((control) => control.value));
  const selected = new Set(controls.filter((control) => control.checked).map((control) => control.value));
  return [...new Set([
    ...(existing ?? []).filter((permission) => !rendered.has(permission) || selected.has(permission)),
    ...selected,
  ])];
}
